import React from 'react';
import Header from './header';
import Footer from './footer';

const Landing: React.FC<React.PropsWithChildren> = ({ children }) => {
    return (
        <div className="bg-[#fafafa] dark:bg-black min-h-screen flex flex-col text-[#333] dark:text-[#f0f0f0]">
            <header className="container mx-auto px-4">
                <Header />
            </header>

            <main className="flex-grow">
                <div className="container mx-auto px-4">
                {children}
                </div>
            </main>

            <footer className="container mx-auto px-4">
                <Footer />
            </footer>
        </div>
    );
};

export default Landing;
